// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import FileCard from "./FileCard";
import PrimaryButton from "./PrimaryButton";
import { ActionPrevProps } from "../types/common";


const ReviewAndconfirmModal = ({showPrev}: ActionPrevProps) => {
  return (
    <>
      <p className="text-[#9392A2] text-xs font-medium tracking-tight mt-3">Please review all your translated video files and<br />price for this actions.</p>
      <FileCard className="w-full mt-2 mb-1"  />
      <FileCard className="w-full mt-2 mb-1"  />
      <FileCard className="w-full mt-2 mb-3" />
      <div className="flex items-center justify-between">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">Cost per one video / 1$ = 1min</p>
        <p className="text-[#0F0C18] text-sm font-medium tracking-tight">$ 15.23</p>
      </div>
      <div className="flex items-center justify-between mt-1">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">Amount for existing translations</p>
        <p className="text-[#9392A2] text-sm font-medium tracking-tight">– $ 25.72</p>
      </div>
      <div className="flex items-center justify-between">
        <p className="text-[#9392A2] text-xs font-medium tracking-tight">Left over amount / 3 videos * $15.23</p>
        <p className="text-[#0F0C18] text-lg font-medium tracking-tight">$ 19.97</p>
      </div>
      <div className="flex items-center gap-1 mt-3">
        <PrimaryButton onClick={() => showPrev && showPrev()} className="py-2 rounded-3xl w-full" black label="Back" />
        <PrimaryButton className="py-2 rounded-3xl w-full" label="Pay & proceed" />
      </div>
    </>
  );
};

export default ReviewAndconfirmModal;